import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../hooks';
import { downloadPlayerTemplateThunk } from './downloadPlayerTemplate.thunk';

interface InitialStateProps {
  url: string;
}

const initialState: InitialStateProps = {
  url: '',
};

export const downloadPlayerUploadTemplateSlice = createSlice({
  name: 'DownloadPlayerTemplate',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(downloadPlayerTemplateThunk.fulfilled, (state, action) => {
      return { ...state, url: action.payload };
    });
  },
});

export const usePlayerTemplateUrlSelector = (state: RootState): string =>
  state.downloadPlayerTemplateReducer.url;
